/* global DownloadURL */

import React from 'react';

import _ from 'topmeteo/utils/i18n';

import BaseTab from './BaseTab';

const FormatLabel = _('Format');

const CUP = '.cup';
const TXT = '.txt';
const DefaultFormat = CUP;
const Formats = [CUP, TXT];

const getFilename = request => request.getResponseHeader('X-Filename');

const handleSuccess = (body, request) => {
    const anchor = document.createElement('a');
    const data = new Blob([body]);

    anchor.href = URL.createObjectURL(data);
    anchor.download = getFilename(request);

    return anchor.click();
};

const DownloadTab = ({label, ...props}) => (
    <BaseTab {...props} action={DownloadURL} buttonLabel={label} onSuccess={handleSuccess}>
        <label htmlFor="format-select">
            <span>{FormatLabel}</span>
            <select id="format-select" name="format" defaultValue={DefaultFormat}>
                {Formats.map(format => <option key={format} value={format}>{format}</option>)}
            </select>
        </label>
    </BaseTab>
);

export default DownloadTab;
